var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHrwsLogoDesc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 506,
    height: 178,
    viewBox: "0 0 506 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 178V0L34.677 76.5784L0 178Z",
    fill: "#E8B500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H58.5175L34.677 76.5784L0 0Z",
    fill: "#FFD94A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5175 0V65.5986L34.677 76.5784L58.5175 0Z",
    fill: "#E8B500"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 178H58.5175L34.677 76.5784L0 178Z",
    fill: "#B77A00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5175 178V111.685L34.677 76.5784L58.5175 178Z",
    fill: "#FFD94A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5175 111.685H123.288L34.677 76.5784L58.5175 111.685Z",
    fill: "#B77A00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5175 65.5986H114.332L113.18 84.5688L79.3747 94.2844L34.677 76.5784L58.5175 65.5986Z",
    fill: "#FFD94A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M123.287 111.685L113.179 84.5688L79.3743 94.2844L123.287 111.685Z",
    fill: "#E8B500"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M113.179 84.5688L131.259 81.4175L114.331 65.5986L113.179 84.5688Z",
    fill: "#E8B500"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M123.287 111.685L131.259 81.4174L113.179 84.5688L123.287 111.685Z",
    fill: "#B77A00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M114.331 65.5986V0.678864L131.259 81.4175L114.331 65.5986Z",
    fill: "#E8B500"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M114.331 0.678864H166.054L131.259 81.4175L114.331 0.678864Z",
    fill: "#FFD94A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M114.331 111.685H123.287L114.331 178V111.685Z",
    fill: "#E8B500"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M114.331 178H166.054L131.259 81.4174L123.287 111.685L114.331 178Z",
    fill: "#FFD94A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M166.055 0.678864V178L131.26 81.4175L166.055 0.678864Z",
    fill: "#E8B500"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M166.054 0.678864H270.322L220.766 32.0738L166.054 0.678864Z",
    fill: "#FFD94A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M166.054 0.678864V82.2147L199.236 41.0482L166.054 0.678864Z",
    fill: "#FFD94A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M199.236 41.0482L220.766 32.0738L166.054 0.678864L199.236 41.0482Z",
    fill: "#E8B500"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M199.236 41.0482L220.766 32.0738L166.054 0.678864L199.236 41.0482Z",
    fill: "url(#paint0_linear_429_2419)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M208.055 45.3704L220.766 32.0738L199.237 41.0482L208.055 45.3704Z",
    fill: "#FFD94A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M208.055 45.3704H241.574L220.767 32.0738L208.055 45.3704Z",
    fill: "#B77A00"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M241.574 45.3704H256.982L220.767 32.0738L241.574 45.3704Z",
    fill: "#FFD94A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M270.322 0.678864L256.982 45.3704L220.767 32.0738L270.322 0.678864Z",
    fill: "#E8B500"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M256.9 45.3704H309.837L270.321 0.678864L256.9 45.3704Z",
    fill: "#FFD94A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M309.838 45.3703V84.1889L277.789 90.2549L309.838 45.3703Z",
    fill: "#FFD94A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M277.788 90.2549L256.9 45.3703H309.837L277.788 90.2549Z",
    fill: "#E8B500"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M256.9 60.2052V45.3703H241.573L256.9 60.2052Z",
    fill: "#E8B500"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M277.788 90.2549L256.9 75.2767V45.3703L277.788 90.2549Z",
    fill: "#B77A00"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M277.789 90.2549H242.726L256.901 75.2767L277.789 90.2549Z",
    fill: "#E8B500"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M262.182 106.049L277.789 90.2549H242.726L262.182 106.049Z",
    fill: "#FFD94A"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M309.837 84.189L262.181 106.049L277.788 90.255L309.837 84.189Z",
    fill: "#B77A00"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M279.519 121.27L309.837 84.189L262.181 106.049L279.519 121.27Z",
    fill: "#E8B500"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M242.726 90.2549H208.055L262.182 106.049L242.726 90.2549Z",
    fill: "#B77A00"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M262.182 106.049L244.85 145.64L279.521 121.27L262.182 106.049Z",
    fill: "#FFD94A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M166.054 178L208.055 118.573V178H166.054Z",
    fill: "#FFD94A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M256.888 178H326.815L244.85 145.64L256.888 178Z",
    fill: "#E8B500"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M281.352 124.446L279.521 121.27L244.85 145.64L281.352 124.446Z",
    fill: "#E8B500"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M326.815 178L281.352 124.446L244.85 145.64L326.815 178Z",
    fill: "#FFD94A"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M256.888 178L208.055 118.573L244.85 145.64L256.888 178Z",
    fill: "#B77A00"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M208.055 90.2549L223.943 113.18L208.055 118.573V90.2549Z",
    fill: "#FFD94A"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M262.182 106.049L223.943 113.18L208.055 90.2549L262.182 106.049Z",
    fill: "#E8B500"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M244.85 145.64L262.182 106.049L223.943 113.18L208.055 118.573L244.85 145.64Z",
    fill: "#FFD94A"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M199.237 41.0482L208.055 55.5779V45.3703L199.237 41.0482Z",
    fill: "#B77A00"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M208.055 90.2549V55.5779L199.236 41.0482L166.054 82.2146V178L208.055 118.573V90.2549Z",
    fill: "#E8B500"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M199.236 41.0482L220.766 32.0738L166.054 0.678864L199.236 41.0482Z",
    fill: "url(#paint1_linear_429_2419)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M262.182 106.049L277.789 90.2549H242.726L262.182 106.049Z",
    fill: "url(#paint2_linear_429_2419)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M0 178V0L34.677 76.5784L0 178Z",
    fill: "#E8B500"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M166.062 0.678864V82.2085L199.244 41.0482L166.062 0.678864Z",
    fill: "url(#paint3_linear_429_2419)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M199.236 41.0482L220.766 32.0738L166.054 0.678864L199.236 41.0482Z",
    fill: "url(#paint4_linear_429_2419)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M166.054 178L208.055 118.573V178H166.054Z",
    fill: "url(#paint5_linear_429_2419)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M208.055 45.3704L220.766 32.0738L199.237 41.0482L208.055 45.3704Z",
    fill: "url(#paint6_linear_429_2419)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M208.055 45.3704H241.574L220.767 32.0738L208.055 45.3704Z",
    fill: "url(#paint7_linear_429_2419)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M241.574 45.3704H256.982L220.767 32.0738L241.574 45.3704Z",
    fill: "url(#paint8_linear_429_2419)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M270.322 0.678864L256.982 45.3704L220.767 32.0738L270.322 0.678864Z",
    fill: "url(#paint9_linear_429_2419)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M256.9 45.3704H309.837L270.321 0.678864L256.9 45.3704Z",
    fill: "url(#paint10_linear_429_2419)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M309.838 45.3703V84.1889L277.789 90.2549L309.838 45.3703Z",
    fill: "url(#paint11_linear_429_2419)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M277.788 90.2549L256.9 45.3703H309.837L277.788 90.2549Z",
    fill: "url(#paint12_linear_429_2419)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M256.9 60.2052V45.3703H241.573L256.9 60.2052Z",
    fill: "url(#paint13_linear_429_2419)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M277.788 90.2549L256.9 75.2767V45.3703L277.788 90.2549Z",
    fill: "url(#paint14_linear_429_2419)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M277.789 90.2549H242.726L256.901 75.2767L277.789 90.2549Z",
    fill: "url(#paint15_linear_429_2419)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M309.837 84.189L262.181 106.049L277.788 90.255L309.837 84.189Z",
    fill: "url(#paint16_linear_429_2419)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M279.519 121.27L309.837 84.189L262.181 106.049L279.519 121.27Z",
    fill: "url(#paint17_linear_429_2419)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M242.726 90.2549H208.055L262.182 106.049L242.726 90.2549Z",
    fill: "url(#paint18_linear_429_2419)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M262.182 106.049L244.85 145.64L279.521 121.27L262.182 106.049Z",
    fill: "url(#paint19_linear_429_2419)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M256.888 178H326.815L244.85 145.64L256.888 178Z",
    fill: "url(#paint20_linear_429_2419)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M281.352 124.446L279.521 121.27L244.85 145.64L281.352 124.446Z",
    fill: "url(#paint21_linear_429_2419)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M326.815 178L281.352 124.446L244.85 145.64L326.815 178Z",
    fill: "url(#paint22_linear_429_2419)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M256.888 178L208.055 118.573L244.85 145.64L256.888 178Z",
    fill: "url(#paint23_linear_429_2419)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M208.055 90.2549L223.943 113.18L208.055 118.573V90.2549Z",
    fill: "url(#paint24_linear_429_2419)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M262.182 106.049L223.943 113.18L208.055 90.2549L262.182 106.049Z",
    fill: "url(#paint25_linear_429_2419)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M244.85 145.64L262.182 106.049L223.943 113.18L208.055 118.573L244.85 145.64Z",
    fill: "url(#paint26_linear_429_2419)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M199.237 41.0482L208.055 55.5779V45.3703L199.237 41.0482Z",
    fill: "url(#paint27_linear_429_2419)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M208.055 90.2549V55.5779L199.236 41.0482L166.054 82.2084V178L208.055 118.573V90.2549Z",
    fill: "url(#paint28_linear_429_2419)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M166.054 0.678864H270.322L220.766 32.0738L166.054 0.678864Z",
    fill: "url(#paint29_linear_429_2419)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M0 177.975V0L34.677 76.5784L0 177.975Z",
    fill: "url(#paint30_linear_429_2419)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M0 0H58.5175L34.677 76.5784L0 0Z",
    fill: "url(#paint31_linear_429_2419)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M58.5175 0V65.5986L34.677 76.5784L58.5175 0Z",
    fill: "url(#paint32_linear_429_2419)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M0 177.975H58.5175L34.677 76.5784L0 177.975Z",
    fill: "url(#paint33_linear_429_2419)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M58.5175 177.975V111.685L34.677 76.5784L58.5175 177.975Z",
    fill: "url(#paint34_linear_429_2419)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M58.5175 111.685H123.288L34.677 76.5784L58.5175 111.685Z",
    fill: "url(#paint35_linear_429_2419)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M58.5175 65.5986H114.332L113.18 84.5688L79.3747 94.2844L34.677 76.5784L58.5175 65.5986Z",
    fill: "url(#paint36_linear_429_2419)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M123.287 111.685L113.179 84.5688L79.3743 94.2844L123.287 111.685Z",
    fill: "url(#paint37_linear_429_2419)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M113.179 84.5688L131.259 81.4175L114.331 65.5986L113.179 84.5688Z",
    fill: "url(#paint38_linear_429_2419)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M123.287 111.685L131.259 81.4174L113.179 84.5688L123.287 111.685Z",
    fill: "url(#paint39_linear_429_2419)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M114.331 65.5986V0.678864L131.259 81.4175L114.331 65.5986Z",
    fill: "url(#paint40_linear_429_2419)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M114.331 0.678864H166.054L131.259 81.4175L114.331 0.678864Z",
    fill: "url(#paint41_linear_429_2419)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M114.331 111.685H123.287L114.331 178V111.685Z",
    fill: "url(#paint42_linear_429_2419)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M114.331 178H166.054L131.259 81.4174L123.287 111.685L114.331 178Z",
    fill: "url(#paint43_linear_429_2419)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M166.055 0.678864V178L131.26 81.4175L166.055 0.678864Z",
    fill: "url(#paint44_linear_429_2419)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M200.737 0.678864H166.054V178H200.737V0.678864Z",
    fill: "url(#paint45_linear_429_2419)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M426.278 115.02C422.85 115.02 420.112 113.997 418.065 111.95C415.865 109.75 414.765 106.372 414.765 101.818C414.765 97.4431 415.827 93.8996 417.95 91.1875C420.099 88.4499 423.195 87.0811 427.238 87.0811C430.564 87.0811 433.545 88.0661 436.18 90.0362L432.687 95.294C430.871 93.9379 429.093 93.2599 427.353 93.2599C425.843 93.2599 424.666 93.7716 423.822 94.795C422.978 95.8185 422.466 97.2129 422.287 98.9783C424.104 97.5966 426.035 96.9058 428.082 96.9058C430.564 96.9058 432.662 97.6606 434.376 99.1701C436.09 100.68 436.947 102.739 436.947 105.349C436.947 108.291 435.924 110.645 433.877 112.411C431.83 114.15 429.297 115.02 426.278 115.02ZM423.208 108.227C423.899 108.893 424.82 109.225 425.971 109.225C427.123 109.225 428.031 108.905 428.696 108.266C429.361 107.601 429.694 106.743 429.694 105.694C429.694 104.722 429.349 103.903 428.658 103.238C427.967 102.573 427.046 102.24 425.895 102.24C424.743 102.24 423.835 102.573 423.17 103.238C422.504 103.878 422.172 104.709 422.172 105.733C422.172 106.731 422.517 107.562 423.208 108.227Z",
    fill: "#E7B400"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M390.509 114.483V108.88L400.564 101.204C401.818 100.258 402.7 99.426 403.212 98.7096C403.749 97.9676 404.018 97.1873 404.018 96.3685C404.018 95.5242 403.737 94.859 403.174 94.3729C402.637 93.8868 401.92 93.6437 401.025 93.6437C400.155 93.6437 399.31 93.9123 398.492 94.4496C397.699 94.9613 396.765 95.844 395.69 97.0977L390.663 92.9145C392.198 90.9189 393.784 89.4605 395.421 88.5394C397.059 87.6183 399.119 87.1578 401.6 87.1578C404.543 87.1578 406.922 87.9637 408.739 89.5756C410.581 91.1619 411.502 93.2343 411.502 95.7929C411.502 97.8141 411.016 99.5028 410.043 100.859C409.071 102.189 407.485 103.635 405.285 105.195L400.679 108.419H411.77V114.483H390.509Z",
    fill: "#E7B400"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M384.571 110.991C382.294 113.677 379.288 115.02 375.553 115.02C371.817 115.02 368.811 113.69 366.534 111.029C364.282 108.343 363.156 105.016 363.156 101.051C363.156 97.1361 364.308 93.8356 366.611 91.1491C368.913 88.4371 371.919 87.0811 375.629 87.0811C379.365 87.0811 382.358 88.4243 384.61 91.1108C386.887 93.7972 388.025 97.1105 388.025 101.051C388.025 104.965 386.874 108.279 384.571 110.991ZM372.022 106.385C372.943 107.741 374.145 108.419 375.629 108.419C377.113 108.419 378.303 107.741 379.199 106.385C380.094 105.004 380.542 103.225 380.542 101.051C380.542 98.9015 380.068 97.1361 379.122 95.7545C378.201 94.3729 377.011 93.6821 375.553 93.6821C374.069 93.6821 372.879 94.3601 371.983 95.7161C371.088 97.0721 370.64 98.8503 370.64 101.051C370.64 103.225 371.101 105.004 372.022 106.385Z",
    fill: "#E7B400"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M338.902 114.483V108.88L348.957 101.204C350.21 100.258 351.093 99.426 351.605 98.7096C352.142 97.9676 352.411 97.1873 352.411 96.3685C352.411 95.5242 352.129 94.859 351.566 94.3729C351.029 93.8868 350.313 93.6437 349.417 93.6437C348.547 93.6437 347.703 93.9123 346.884 94.4496C346.091 94.9613 345.157 95.844 344.083 97.0977L339.055 92.9145C340.59 90.9189 342.177 89.4605 343.814 88.5394C345.451 87.6183 347.511 87.1578 349.993 87.1578C352.935 87.1578 355.315 87.9637 357.131 89.5756C358.973 91.1619 359.894 93.2343 359.894 95.7929C359.894 97.8141 359.408 99.5028 358.436 100.859C357.464 102.189 355.878 103.635 353.677 105.195L349.072 108.419H360.163V114.483H338.902Z",
    fill: "#E7B400"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M364.368 27.7906C362.646 22.8895 360.922 17.9788 359.201 13.0681C359.147 13.0744 359.094 13.0808 359.037 13.0871C357.332 17.9851 355.626 22.88 353.915 27.7906H347.602C344.715 19.0967 341.823 10.3807 338.902 1.5794H346.56C348.028 6.4648 349.512 11.3976 350.997 16.3303C351.05 16.3303 351.101 16.3303 351.155 16.3272C352.797 11.3881 354.439 6.45216 356.084 1.5036H362.343C363.989 6.46795 365.628 11.4102 367.267 16.3524C367.317 16.3461 367.364 16.3366 367.415 16.3303C368.899 11.4133 370.38 6.49637 371.868 1.56676H379.387C376.469 10.3554 373.576 19.0746 370.68 27.797H364.371L364.368 27.7906Z",
    fill: "#090909"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M399.847 46.2301C400.172 46.2301 400.412 46.2301 400.652 46.2301C402.683 46.2301 404.717 46.2491 406.747 46.2175C407.278 46.208 407.568 46.3785 407.846 46.8333C409.599 49.7291 411.386 52.6029 413.161 55.483C413.3 55.7104 413.452 55.9314 413.679 56.2756C415.782 52.9124 417.791 49.5965 419.856 46.2743H427.505V72.1982C426.924 72.3782 421.312 72.4192 420.323 72.2361V57.7567C420.27 57.7378 420.216 57.7188 420.159 57.6999C419.553 58.4673 419.07 59.3262 418.523 60.1378C417.98 60.9463 417.456 61.7705 416.922 62.5853C416.376 63.4253 415.83 64.2653 415.28 65.1022C414.75 65.9106 414.219 66.7191 413.606 67.6538C412.785 66.517 412.116 65.418 411.405 64.3506C410.673 63.2453 409.953 62.1305 409.223 61.0221C408.519 59.9452 407.812 58.8715 407.006 57.8199C406.899 59.042 406.908 60.2421 406.905 61.4421C406.905 62.6326 406.905 63.8264 406.905 65.0169V72.2834H399.844V46.2269L399.847 46.2301Z",
    fill: "#090909"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M448.619 56.282C450.719 52.8776 452.749 49.587 454.793 46.2711H462.321C462.511 46.8522 462.568 71.2445 462.378 72.2866H455.282V57.6873C454.862 57.8104 454.777 58.1199 454.628 58.3441C452.772 61.1737 450.927 64.0127 449.077 66.8454C448.919 67.0854 448.748 67.3191 448.511 67.6538C446.31 64.2969 444.179 61.0473 442.047 57.7978C441.99 57.8041 441.933 57.8104 441.877 57.8167C441.861 58.0883 441.829 58.3567 441.829 58.6283C441.829 62.8537 441.829 67.0791 441.829 71.3045C441.829 71.6203 441.829 71.9329 441.829 72.2898H434.793V46.2901C434.995 46.268 435.201 46.2269 435.406 46.2269C437.519 46.2206 439.631 46.2396 441.744 46.2111C442.249 46.2048 442.514 46.4006 442.764 46.8112C444.523 49.7007 446.307 52.5808 448.085 55.4609C448.224 55.6882 448.376 55.9093 448.616 56.2725L448.619 56.282Z",
    fill: "#090909"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M492.003 11.5871C494.125 8.14802 496.169 4.83846 498.196 1.551H505.709C505.889 2.14154 505.946 26.4896 505.769 27.5822H498.667V12.8692C497.978 13.5482 497.647 14.2492 497.217 14.8745C496.772 15.5219 496.355 16.1882 495.925 16.8451C495.48 17.5241 495.038 18.2062 494.593 18.8852C494.163 19.542 493.737 20.202 493.307 20.8589C492.881 21.5126 492.452 22.1631 491.95 22.9242C491.274 22.0684 490.781 21.2126 490.235 20.3978C489.692 19.5894 489.164 18.7683 488.631 17.9536C488.081 17.1167 487.532 16.2767 486.982 15.4398C486.451 14.6345 485.921 13.8292 485.39 13.0239C485.334 13.0397 485.277 13.0524 485.22 13.0682V27.5886H478.197V1.55732C478.452 1.54469 478.664 1.52574 478.875 1.52574C480.963 1.52574 483.047 1.53837 485.135 1.5131C485.634 1.50679 485.908 1.68364 486.161 2.10049C487.876 4.92373 489.616 7.73117 491.35 10.5449C491.533 10.8418 491.722 11.1386 492.006 11.5902L492.003 11.5871Z",
    fill: "#090909"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M418.739 27.5854V1.56363C419.045 1.54784 419.307 1.52257 419.572 1.52257C422.743 1.52257 425.91 1.50363 429.081 1.52573C431.822 1.54784 434.475 2.02786 436.928 3.30684C440.819 5.33426 442.891 8.61224 443.383 12.9229C443.687 15.5661 443.317 18.1115 442.111 20.5052C440.437 23.8337 437.671 25.8074 434.168 26.8654C432.416 27.3959 430.616 27.6075 428.797 27.6233C425.655 27.6517 422.512 27.6328 419.37 27.6296C419.184 27.6296 419.001 27.6043 418.739 27.5822V27.5854ZM425.989 21.3042C427.537 21.2505 429.008 21.3073 430.448 21.1273C433.575 20.7357 435.593 18.7367 435.984 15.6577C436.594 10.8544 433.597 8.31539 430.174 7.98696C428.964 7.87011 427.742 7.90485 426.526 7.87959C426.349 7.87643 426.172 7.93012 425.989 7.95854V21.3073V21.3042Z",
    fill: "#090909"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M474.344 14.0787C474.338 21.0389 469.797 26.5812 463.415 27.8254C458.643 28.757 454.285 27.8096 450.615 24.5221C444.347 18.9104 444.997 8.58066 451.866 3.68263C456.814 0.155162 463.768 0.0856903 468.726 3.59737C472.491 6.26586 474.221 10.0302 474.341 14.0755L474.344 14.0787ZM466.993 14.7924C467.005 12.386 466.197 10.5291 464.542 9.06699C462.24 7.03325 458.491 7.02693 456.173 8.99751C452.914 11.7639 452.829 17.4041 456.328 20.2368C458.851 22.28 462.723 22.0716 464.984 19.7473C466.377 18.3167 467.008 16.5798 466.996 14.7956L466.993 14.7924Z",
    fill: "#090909"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M368.656 46.2743H375.954C375.954 46.6312 375.954 46.947 375.954 47.2628C375.954 51.5955 375.945 55.9314 375.964 60.2642C375.967 61.0442 376.008 61.8432 376.169 62.6042C376.677 65.0453 378.392 66.3812 380.881 66.2738C381.598 66.2422 382.352 66.1128 383.006 65.8349C384.617 65.1527 385.286 63.7632 385.488 62.1084C385.545 61.6537 385.542 61.1895 385.545 60.7284C385.548 56.2598 385.545 51.7913 385.545 47.3196V46.3785C386.205 46.1954 391.949 46.1669 392.853 46.3343C392.865 46.6091 392.887 46.8964 392.887 47.187C392.887 51.7661 392.894 56.342 392.887 60.921C392.887 62.3327 392.733 63.7285 392.373 65.099C391.406 68.7749 389.066 71.1276 385.454 72.1761C382.4 73.0603 379.299 73.0856 376.229 72.2456C372.108 71.1182 369.686 68.3896 368.934 64.2022C368.738 63.1158 368.637 61.9979 368.631 60.8926C368.599 56.2346 368.615 51.5734 368.618 46.9154C368.618 46.7291 368.64 46.5427 368.656 46.2743Z",
    fill: "#090909"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M414.517 4.56373C413.292 6.29431 412.108 7.96172 410.911 9.64809C410.266 9.26913 409.698 8.90912 409.108 8.59016C407.541 7.74382 405.877 7.19118 404.083 7.14381C403.496 7.12802 402.886 7.16907 402.318 7.30486C401.506 7.50065 401.023 8.08489 401.004 8.77017C400.982 9.54387 401.396 10.087 402.09 10.3207C403.291 10.7281 404.519 11.0597 405.735 11.4166C407.033 11.7955 408.346 12.1239 409.622 12.5629C410.383 12.8219 411.113 13.2071 411.817 13.6019C414.536 15.1209 415.471 17.5336 415.18 20.5179C414.887 23.5432 413.241 25.6117 410.548 26.9001C408.858 27.7086 407.052 28.0086 405.192 28.0465C401.194 28.1286 397.455 27.2665 394.088 25.0338C393.684 24.7653 393.305 24.4559 392.92 24.1559C392.771 24.0422 392.642 23.9064 392.44 23.72C393.772 22.1316 395.089 20.5652 396.457 18.9389C396.719 19.122 396.952 19.2862 397.186 19.4536C399.69 21.2379 402.45 22.2105 405.555 21.9989C406.054 21.9642 406.584 21.8347 407.023 21.601C408.138 21.0168 408.201 19.6399 407.143 18.961C406.651 18.6452 406.079 18.4178 405.514 18.2567C404.083 17.8494 402.624 17.5367 401.2 17.1167C400.088 16.7883 398.97 16.4314 397.916 15.9483C394.262 14.2714 393.065 11.3092 393.883 7.52276C394.552 4.42162 396.725 2.63737 399.634 1.67734C401.652 1.01101 403.739 1.00785 405.826 1.19417C408.795 1.45629 411.539 2.36894 413.971 4.14057C414.122 4.25109 414.268 4.37426 414.511 4.56373H414.517Z",
    fill: "#090909"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M340.092 68.4275C341.447 66.8201 342.77 65.2506 344.119 63.6464C344.422 63.8643 344.681 64.0537 344.946 64.2369C347.416 65.9675 350.131 66.9117 353.176 66.7127C353.675 66.6812 354.208 66.558 354.651 66.3306C355.81 65.7369 355.866 64.3411 354.764 63.6464C354.291 63.3464 353.747 63.1285 353.207 62.9769C351.752 62.5663 350.267 62.2442 348.815 61.8179C347.754 61.5084 346.702 61.1389 345.682 60.7126C339.679 58.2083 340.496 50.8471 344.125 48.0649C345.679 46.8743 347.406 46.1543 349.32 45.949C352.974 45.5543 356.514 45.9869 359.808 47.7238C360.613 48.1501 361.361 48.6838 362.211 49.2175C360.957 50.9829 359.776 52.6534 358.56 54.3651C358.27 54.1882 358.02 54.0366 357.774 53.885C355.907 52.7197 353.915 51.9176 351.688 51.8513C351.101 51.8355 350.495 51.8955 349.926 52.0345C349.216 52.205 348.723 52.6818 348.663 53.4492C348.603 54.2198 349.017 54.7819 349.711 55.0188C350.937 55.4388 352.194 55.7672 353.435 56.1398C354.91 56.582 356.403 56.9767 357.846 57.5041C358.649 57.7978 359.406 58.262 360.12 58.742C362.46 60.3115 363.089 62.6295 362.827 65.2759C362.52 68.3739 360.774 70.4297 358.014 71.7055C356.849 72.2455 355.607 72.555 354.338 72.6687C350.308 73.0287 346.456 72.4224 342.874 70.4455C341.88 69.896 340.948 69.2549 340.089 68.4244L340.092 68.4275Z",
    fill: "#090909"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M483.057 46.2775H505.728C505.918 46.8522 505.971 51.4218 505.788 52.5776H498.048V72.2834H490.826C490.81 65.759 490.826 59.2441 490.816 52.6282C488.224 52.5208 485.666 52.6345 483.054 52.5618V46.2775H483.057Z",
    fill: "#090909"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M382.453 1.56046H389.556V27.5822H382.453V1.56046Z",
    fill: "#090909"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M477.009 46.2901V72.214C476.409 72.3719 471.091 72.4161 469.97 72.2771C469.8 71.7118 469.727 47.6607 469.901 46.2901H477.009Z",
    fill: "#090909"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_429_2419",
    x1: 220.766,
    y1: 20.8635,
    x2: 166.054,
    y2: 20.8635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_429_2419",
    x1: 166.054,
    y1: -22.489,
    x2: 220.766,
    y2: 20.8635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_429_2419",
    x1: 273.941,
    y1: 95.1314,
    x2: 247.26,
    y2: 98.8868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FFFCF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFF6D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFEDAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFE06D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_429_2419",
    x1: 198.839,
    y1: 44.8908,
    x2: 161.821,
    y2: 40.9984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FFFBEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFF2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFEA9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFE47E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFDF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFDB56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFD94D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_429_2419",
    x1: 193.451,
    y1: 16.3047,
    x2: 184.183,
    y2: 32.3603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_429_2419",
    x1: 190.175,
    y1: 150.037,
    x2: 201.011,
    y2: 156.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_429_2419",
    x1: 199.237,
    y1: 38.7252,
    x2: 220.766,
    y2: 38.7252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_429_2419",
    x1: 208.055,
    y1: 38.7252,
    x2: 241.574,
    y2: 38.7252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_429_2419",
    x1: -22.5265,
    y1: 38.7252,
    x2: 256.982,
    y2: 38.7252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_429_2419",
    x1: 240.565,
    y1: 11.5715,
    x2: 265.95,
    y2: 36.0845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_429_2419",
    x1: 294.093,
    y1: 17.0832,
    x2: 267.02,
    y2: 57.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFF3C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFE892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFDF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FFDA52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_429_2419",
    x1: 317.461,
    y1: 79.9788,
    x2: 290.98,
    y2: 66.3521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFFEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFFBEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFF7DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFF1BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFE99A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FFE06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_429_2419",
    x1: 256.9,
    y1: 67.8095,
    x2: 309.837,
    y2: 67.8095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_429_2419",
    x1: 241.573,
    y1: 52.7877,
    x2: 256.9,
    y2: 52.7877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_429_2419",
    x1: 256.9,
    y1: 67.8095,
    x2: 277.788,
    y2: 67.8095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_429_2419",
    x1: 242.726,
    y1: 82.7627,
    x2: 277.789,
    y2: 82.7627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_429_2419",
    x1: 262.181,
    y1: 95.119,
    x2: 309.837,
    y2: 95.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_429_2419",
    x1: 262.181,
    y1: 102.729,
    x2: 309.837,
    y2: 102.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_429_2419",
    x1: 208.055,
    y1: 98.1519,
    x2: 262.182,
    y2: 98.1519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_429_2419",
    x1: 264.493,
    y1: 111.903,
    x2: 261.46,
    y2: 140.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFFAEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FFEEB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#FFE585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FFDA51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_429_2419",
    x1: 244.85,
    y1: 161.82,
    x2: 326.815,
    y2: 161.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_429_2419",
    x1: 244.85,
    y1: 133.452,
    x2: 281.352,
    y2: 133.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_429_2419",
    x1: 244.85,
    y1: 151.226,
    x2: 326.815,
    y2: 151.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FFFBEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFF2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFEA9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFE47E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFDF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFDB56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFD94D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_429_2419",
    x1: 208.055,
    y1: 148.287,
    x2: 256.888,
    y2: 148.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_429_2419",
    x1: 214.676,
    y1: 113.554,
    x2: 208.317,
    y2: 102.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFF8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFE894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_429_2419",
    x1: 208.055,
    y1: 101.714,
    x2: 262.182,
    y2: 101.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_429_2419",
    x1: 228.041,
    y1: 108.104,
    x2: 252.311,
    y2: 125.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFEFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFF1BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFE68B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FFDA51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_429_2419",
    x1: 199.237,
    y1: 48.3161,
    x2: 208.055,
    y2: 48.3161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_429_2419",
    x1: 166.054,
    y1: 109.524,
    x2: 208.055,
    y2: 109.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_429_2419",
    x1: 218.175,
    y1: -0.230412,
    x2: 218.736,
    y2: 32.1111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FFFBEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFF2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFEA9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFE47E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFDF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFDB56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFD94D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_429_2419",
    x1: 0,
    y1: 88.9906,
    x2: 34.677,
    y2: 88.9906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_429_2419",
    x1: 29.6449,
    y1: 9.82765,
    x2: 30.8033,
    y2: 39.0116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFF3C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFE791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFDF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFDA52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_429_2419",
    x1: 46.1239,
    y1: 38.1335,
    x2: 65.3993,
    y2: 44.3988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_429_2419",
    x1: 24.8494,
    y1: 187.024,
    x2: 61.4944,
    y2: 86.3375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_429_2419",
    x1: 62.2853,
    y1: 118.218,
    x2: 33.5809,
    y2: 134.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_429_2419",
    x1: 58.3306,
    y1: 111.461,
    x2: 96.3396,
    y2: 79.5678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_429_2419",
    x1: 72.2375,
    y1: 89.0716,
    x2: 80.0411,
    y2: 49.7735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFE586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_429_2419",
    x1: 123.287,
    y1: 98.127,
    x2: 79.3743,
    y2: 98.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_429_2419",
    x1: 123.193,
    y1: 73.0347,
    x2: 113.372,
    y2: 84.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_429_2419",
    x1: 113.179,
    y1: 96.5513,
    x2: 131.259,
    y2: 96.5513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_429_2419",
    x1: 105.818,
    y1: 50.8509,
    x2: 133.931,
    y2: 34.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_429_2419",
    x1: 140.383,
    y1: 5.44322,
    x2: 141.541,
    y2: 34.6272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FFEEAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFDF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_429_2419",
    x1: 107.294,
    y1: 142.183,
    x2: 121.83,
    y2: 145.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C28F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D0A95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#DDC086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F0E3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F6EFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FBF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FEFDFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_429_2419",
    x1: 140.196,
    y1: 172.208,
    x2: 140.196,
    y2: 129.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFFAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FFEFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FFDD61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FFD94A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_429_2419",
    x1: 166.055,
    y1: 89.3394,
    x2: 131.26,
    y2: 89.3394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B97E09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C69637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#D2AD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#DDC087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#E6D1A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#EEE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F4EBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#F9F4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FCFAF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEFEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_429_2419",
    x1: 166.054,
    y1: 89.3394,
    x2: 200.743,
    y2: 89.3394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B77A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrwsLogoDesc);
export default __webpack_public_path__ + "static/media/hrws_logo_desc.611b7d2da50470a8d27d43b4dc16fac4.svg";
export { ForwardRef as ReactComponent };